import { Tag } from '@cencosud-cencommerce/paris-uikit';

import { useAppSelector } from '@/Application/Hooks/Redux';
import {
  formatPrice,
  useGetCartTotals,
  useGiftCardData
} from '@/modules/perseo-billing/hooks';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src';

interface ICardSaving {
  isCencosudCard: boolean;
}

export const CardSaving = ({ isCencosudCard }: ICardSaving): JSX.Element => {
  const { data: cart } = useAppSelector((state) => state.cart);
  const { otherMethods, cencosudCard } = useGetCartTotals();
  const { cartHasGiftCardPayment } = useGiftCardData();

  const isMobile = useMediaQuery('lg');

  if (!cart) return <></>;
  const hasGiftCardApplied = cartHasGiftCardPayment();
  const cencosudSaveAmount = otherMethods?.amount - cencosudCard?.amount;
  const saveAmount = formatPrice(cencosudSaveAmount);
  const saveAmountLabel = 'Ahorra ' + saveAmount;

  if (isCencosudCard && cencosudSaveAmount > 0 && !hasGiftCardApplied) {
    return (
      <Tag size={isMobile ? 'md' : 'lg'} variant="offers">
        {saveAmountLabel}
      </Tag>
    );
  }
  return <></>;
};
